import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';
import { AlertController, PopoverController } from '@ionic/angular';
import { LoadingController, ToastController, ModalController } from '@ionic/angular';
import { DatePipe, formatDate } from '@angular/common';
import { CancelbookingPage } from '../cancelbooking/cancelbooking.page';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { ReviewPage } from '../review/review.page';
import { ViewmodelPage } from '../viewmodel/viewmodel.page';
import { AddCall } from 'src/providers/addvCall';
import { ModpricetagPage } from '../modpricetag/modpricetag.page'
import { DefinedDutiesPage } from '../../app/nurse-booking/defined-duties/defined-duties.page';

@Component({
  selector: 'app-nurse-booking',
  templateUrl: './nurse-booking.page.html',
  styleUrls: ['./nurse-booking.page.scss'],
})
export class NurseBookingPage implements OnInit {

  @Output() nurserepeatpagedata = new EventEmitter<object>();
  @Output() ChangeEventNurse = new EventEmitter<string>();
  @Output() ChangeEvent = new EventEmitter<string>();
  dateFormate = new Date();
  dateInfo: any;
  date: string;
  year: string;
  month: string;
  day: string;
  curntDate: any;
  NurseBooking = [];
  mySchedules = [];
  partBookingDetails = [];
  partBookingHistory = [];
  nurseBookingId: any;
  EmtyData: any;
  myScheDulePage: any = [];
  cancelResponse: any;
  today: any;
  dtyArray = [];
  dtyArr: string;
  nextCount: any;
  nextCount1: any;
  pageno1: any;
  pageno2: any;
  disabled: boolean = false;
  res: any;
  storeDates: any = [];
  myFromDate: any;
  myToDate: any;
  chkCrnDate: any;
  crnDate: any;
  crnYear: any;
  crnMonth: any;
  excludedDate: any;
  nextBtn: boolean;
  prevBtn: boolean;
  getBtwDayslist: { totalDays: any; reminingDays: any; completedDays: any };
  remaingDates: any;
  comdate: any;
  patientName: any;
  refEvent: any;
  scrollEvent: any;
  bookListReq: any;
  cancelNurseReq: any;
  partBookDetReq: any;
  nurseBookHisReq: any;
  excluded_date: any;
  excd = [];
  viewdate: string;
  excluded_dat: any;
  dateRange: any[];
  myDates: any;
  formDateArr: any;
  excluformDate: boolean;
  showsheduledate: any; @Input() showTypeofBooking;
  patientid: any;
  patient_id: any;
  isShowHeaderValue: any;
  address: any
  startDate1: any;
  endDate1: any;
  dayDifference: number;
  displayValue: any;
  pricemonth: any;   nextMon: any;
  currentMon: any;

  constructor(
    public router: Router,
    public alertCtrl: AlertController,
    public activeRoute: ActivatedRoute,
    private services: ServicesProvider,
    public loadingController: LoadingController,
    public toastController: ToastController,
    private datePipe: DatePipe,
    public modalCtrl: ModalController,
    public addCall: AddCall,
    private popoverctrl: PopoverController,
  ) {
  }
  presentView: String;
  bookingPage: boolean;
  viewBooking: boolean;
  bookingHistory: boolean;
  viewBookingHistory: boolean;
  schedule: boolean;
  showRefundPopUp: boolean;
  commonheadervalue: string = 'nurse';

  option = {
    percent: 50,
    maxPercent: 100,
    startFromZero: false,
    radius: 15,
    outerStrokeWidth: 3,
    outerStrokeColor: 'let(--app-theme)',
    animation: true,
    animationDuration: 500,
    showInnerStroke: false,
    space: -13,
    backgroundStrokeWidth: 3,
    backgroundStroke: '#e8e8e8',
    backgroundPadding: -2,
    showSubtitle: false,
    showUnits: false,
    showTitle: false
  }
  option1 = {
    percent: 50,
    maxPercent: 100,
    startFromZero: false,
    radius: 15,
    outerStrokeWidth: 3,
    outerStrokeColor: 'let(--app-theme)',
    animation: true,
    animationDuration: 500,
    showInnerStroke: false,
    space: -13,
    backgroundStrokeWidth: 3,
    backgroundStroke: '#e8e8e8',
    backgroundPadding: -2,
    showSubtitle: false,
    showUnits: false,
    showTitle: false,
    clockwise: false
  }

  onDateChanged($event) {
    this.dateInfo = $event;
    let item = this.dateInfo.jsdate;
    let dateArray = String(item).split(" ");
    this.year = dateArray[3];
    this.month = dateArray[1];
    this.day = item.toLocaleString('en-us', { weekday: 'long' });
  }

  ngOnChanges() {
    this.commonheadervalue = "commonbooking"
    if (this.showTypeofBooking == "booking" || this.showTypeofBooking == "") {
      this.NurseBookedListPage();
    }
    else if (this.showTypeofBooking == "booking hitory") {
      this.openHistory();
    }
    else if (this.showTypeofBooking == "viewbooking") {
      let nurseBookingId = localStorage.getItem('NurseViewBookingId');
      this.openViewBooking(nurseBookingId);
    }

  }


  ngOnInit() {
    let date = new Date();
    let day = date.toLocaleString('en-us', { weekday: 'long' });
    this.curntDate = new Date();
    this.curntDate = String(this.curntDate).split(" ");
    this.year = this.curntDate[3];
    this.month = this.curntDate[1];
    this.day = day;
    this.dateFormate = new Date();
  }

  getBtwDays(start, end) {
    let remDate = [];
    let completed_days = [];
    for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
      arr.push(new Date(dt));
      let date1 = new Date(dt);
      let date2 = new Date();
      date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
      if (date1 > date2) {
        remDate.push(new Date(dt));
      }
      else if (date1 < date2) {
        completed_days.push(new Date(dt))
      }
    }

    this.getBtwDayslist = {
      totalDays: arr.length,
      reminingDays: remDate.length - 1,
      completedDays: completed_days.length + 1
    }
    console.log(this.getBtwDayslist, "================")
    return this.getBtwDayslist;
  }

  getpreviwesDate(start) {
    let crnDate = new Date();
    if (start <= crnDate) {
      for (var arr = [], dt = new Date(start); dt < crnDate; dt.setDate(dt.getDate() + 1)) {
        arr.push(new Date(dt));
      }
      return arr;
    }
    else {
      return null;
    }
  }

  doRefresh(event: any, value: any) {
    this.refEvent = event;
    this.pageno1 = 1;
    this.pageno2 = 1;
    if (value == 'listBooking') {
      this.getNurseList("refersh")
    }
    else if (value == 'listBookingHis') {
      this.getNurseListHistory("Refresh");
    }
  }

  async presentLoading() {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Please wait...',
      duration: 1500
    });
    await loading.present();
    const { role, data } = await loading.onDidDismiss();
  }

  async cancelToast(text) {
    const toast = await this.toastController.create({
      message: text, duration: 2000, cssClass: 'myToastStyleBig',
    });
    toast.present();
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }

    let Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(":");
        let H = +String(Value).substring(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = (H < 12 || H === 24) ? "AM" : "PM";
        let timeString = h + String(Value).substring(hourEnd, 5) + " " + ampm;
        if (h < 10) {
          timeString = '0' + timeString;
        }
        return timeString;
      case "Date":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
      case "Date1":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy")
        } else {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "إبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          let days = ["اﻷحد", "اﻷثنين", "الثلاثاء", "اﻷربعاء", "الخميس", "الجمعة", "السبت"];
          let day = String(dateCall.getDate()).padStart(2, '0');
          let arDate = day + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  async Alertpopup(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        'msg': msg,
        'sts': status,
      }
    });
    await alert.present();
  }

  ionViewWillEnter() {
    this.commonheadervalue = 'nurseheader';
    this.currentMon = "";
    this.nextMon = "";
    switch (localStorage.getItem("GoBackToNursBooked")) {
      case "fromNurseSearchList": {
        this.NurseBookedListPage();
        break;
      }
      case "rescheduleNurseList": {
        console.log('back to dutiers');
        this.NurseBookedListPage();
        break;
      }
      case "repeatNurseList": {
        this.commonheadervalue = 'nurseheader';
        this.openHistory();
        break;
      }
      case "particularBookingDetails": {
        let nursebooking_id = this.activeRoute.snapshot.paramMap.get('nursebooking')
        console.log(nursebooking_id, '-=-=-=-=');
        this.dtyArray = [];
        this.openViewBooking(nursebooking_id)
        break;
      }
      default: {
        this.NurseBookedListPage();
      }
    }
  
  }

  ionViewWillLeave() {
    this.scrollEvent = null;
  }

  NurseBookedListPage() {
    this.dtyArray = [];
    this.today = new Date().toISOString().split("T")[0];
    this.presentView = "bookingPage";
    this.bookingPage = true;
    this.viewBooking = false;
    this.bookingHistory = false;
    this.viewBookingHistory = false;
    this.schedule = false;
    this.showRefundPopUp = false;
    this.getNurseList(2);
  }

  backToNurseList() {
    localStorage.setItem("NopayGoBack", "backToNurseListPage");
    this.router.navigate(['/tabs/nursing']);
    this.bookingPage = false;
    this.viewBooking = false;
    this.bookingHistory = false;
    this.viewBookingHistory = false;
    this.schedule = false;
    this.showRefundPopUp = false;
  }

  openViewBooking(nurseBookingId) {
    this.nurseBookingId = nurseBookingId;
    this.ChangeEventNurse.emit("profile");
    this.particularBookingDetails();
    this.presentView = "viewBooking";
    this.commonheadervalue = "nurseheader";
    this.viewBooking = true;
    this.bookingPage = false;
    this.bookingHistory = false;
    this.viewBookingHistory = false;
    this.schedule = false;
  }

  backToBookingPage() {
    this.ChangeEventNurse.emit("isNurseBackBooking");
    this.NurseBookedListPage();
    this.dtyArray = [];
    this.presentView = "bookingPage";
    this.bookingPage = false;
    this.commonheadervalue = "nurseheader";
    this.viewBooking = false;
    this.bookingHistory = false;
    this.viewBookingHistory = false;
    this.schedule = false;
  }

  openHistory() {
    this.dtyArray = [];
    this.ChangeEventNurse.emit('isNurseBackHistory');
    this.getNurseListHistory(1);
    this.presentView = "bookingHistory";
    this.bookingHistory = false;
    this.bookingPage = false;
    this.viewBooking = false;
    this.viewBookingHistory = false;
    this.schedule = false;
  }

  backTo1BookingPage() {
    this.today = new Date().toISOString().split("T")[0];
    this.getNurseList(3);
    this.presentView = "bookingPage";
    this.bookingPage = true;
    this.viewBooking = false;
    this.bookingHistory = false;
    this.viewBookingHistory = false;
    this.schedule = false;
  }

  openViewBookingHistoy(index, nurseBookingId) {
    this.ChangeEventNurse.emit("profile");
    this.nurseBookingId = nurseBookingId;
    this.particularBookingDetails();
    this.presentView = "viewBookingHistory";
    this.viewBookingHistory = true;
    this.bookingPage = false;
    this.viewBooking = false;
    this.bookingHistory = false;
    this.schedule = false;
    this.commonheadervalue = "nurseheader";
  }

  backToBookingHistory() {
    this.ChangeEventNurse.emit("isNurseBackHistory");
    this.dtyArray = [];
    this.presentView = "bookingHistory";
    this.bookingHistory = false;
    this.bookingPage = false;
    this.viewBooking = false;
    this.viewBookingHistory = false;
    this.schedule = false;
  }

  gymrat: any[] = [];
  openMySchedule() {
    debugger
    this.gymrat = [];
    this.excluformDate = false;
    this.nextBtn = true;
    this.prevBtn = false;
    this.myScheDulePage = this.partBookingDetails[0];
    this.patientName = this.myScheDulePage.patientName;
    let fromDate = this.myScheDulePage.from_date.split("T")[0];
    this.formDateArr = this.myScheDulePage.from_date.split("T")[0];
    let toDate = this.myScheDulePage.to_date.split("T")[0];
    this.gymrat = this.myScheDulePage.excluded_date.split(",")
    this.excludedDate = this.myScheDulePage.excluded_date.split(",");
    let setLabel = new Date(fromDate);
    let dateArray = String(setLabel).split(" ");
    this.year = dateArray[3];
    this.month = dateArray[1];
    console.log("fromDate", fromDate);
    console.log("ToDate", toDate);
    this.myFromDate = new Date(fromDate.split("-")[0], (fromDate.split("-")[1] - 1), fromDate.split("-")[2]);
    this.myToDate = new Date(toDate.split("-")[0], (toDate.split("-")[1] - 1), toDate.split("-")[2]);
    console.log("myFromDate", this.myFromDate);
    console.log("myToDate", this.myToDate);
    this.currentMon = new Date(this.myFromDate.getFullYear(), this.myFromDate.getMonth());
    this.showsheduledate = this.myFromDate.toString().split(' ')[0] + ", " + this.myFromDate.toString().split(' ')[1] + " " + this.myFromDate.toString().split(' ')[2]
    this.chkCrnDate = new Date();
    this.crnDate = new Date().getDate();
    this.crnYear = new Date().getFullYear();
    this.crnMonth = new Date().getMonth() + 1;
    console.log("remDateCAlc", this.getBtwDays(new Date(fromDate), new Date(toDate)));
    let dates = this.getBtwDays(new Date(fromDate), new Date(toDate));
    if (dates.reminingDays < 10) {

      this.remaingDates = '0' + dates.reminingDays;
    }
    else {
      this.remaingDates = dates.reminingDays;
    }
    console.log("rat", this.remaingDates);


    if (this.gymrat[0] != "") {
      console.log("shouldoverflow");
      if (this.excludedDate.length > 0) {

        let exdates = this.excludedDate.length
        this.remaingDates = this.remaingDates - exdates;
      }
      console.log("kinh", this.remaingDates);
    }



    let getDate = new Date();
    let currentDate = getDate.getFullYear() + "-" + ("0" + (getDate.getMonth() + 1)).slice(-2) + "-" + ("0" + getDate.getDate()).slice(-2);
    if (this.formDateArr > currentDate) {
      this.excluformDate = true;
    } else {
      this.excluformDate = false
    }
    this.option.percent = (dates.reminingDays / dates.totalDays) * 100;
    if (dates.completedDays < 10) {
      this.comdate = '0' + dates.completedDays
    }
    else {
      this.comdate = dates.completedDays
    }
    this.option1.percent = (this.comdate / dates.totalDays) * 100;
    this.getBkgDateCale(new Date(fromDate), new Date(toDate));
    this.presentView = "schedule";
    this.schedule = true;
    this.bookingHistory = false;
    this.bookingPage = false;
    this.viewBooking = false;
    this.viewBookingHistory = false;
  }
  backToViewBooking() {
    this.presentView = "viewBooking";
    this.viewBooking = true;
    this.schedule = false;
  }

  rescheduleIt(nurseBookingId, patientId) {
    console.log("nurseBookingId => ", nurseBookingId);
    localStorage.setItem("NopayGoBack", "reschedulePage");
    this.router.navigate(['/tabs/nursing', { nurseBookingId: nurseBookingId, patientId: patientId }]);
  }

  isShowNurseBooking: Boolean = false;
  repeatIt(nurseBookingId, patientId) {
    localStorage.setItem("NopayGoBack", "repeatPage");
    this.nurserepeatpagedata.emit({ nurseBookingId: nurseBookingId, patientId: patientId });
    this.ChangeEventNurse.emit('profile');
  }
  editdesign(value) {
    console.log("check log", value);
    localStorage.setItem("NopayGoBack", "editdesign");
    this.nurserepeatpagedata.emit({ nurseBookingId: value.nurseBookingId, patientId: value.patient_id, nurseId: value.nurse_id });
  }

  opennursedetails(item, pagetype) {
    let objectostr = JSON.stringify(item)
    if (pagetype == 1) {
      localStorage.setItem("NopayGoBack", "nursedetails");
      this.router.navigate(['/tabs/nursing', { item: objectostr }]);
    }
    else {
      localStorage.setItem("NopayGoBack", "nursedetailshistory");
      this.router.navigate(['/tabs/nursing', { item: objectostr }]);
    }
  }

  refundOptionToBack() {
    this.showRefundPopUp = false;
  }
  refundAmount() {
    this.patientNurseCancelBooking();
    this.showRefundPopUp = false;
  }
  processRefund() {
    this.patientNurseCancelBooking();
    this.showRefundPopUp = false;
  }

  getNurseList(value) {
    this.pageno1 = 1;
    this.NurseBooking = [];
    this.EmtyData = null;
    this.getNurseBookinglist();
  }

  loadData1(event: any) {
    this.scrollEvent = event;
    if (this.nextCount == 0) {
      event.target.disabled = true;
    } else {
      this.pageno1 += 1;
      this.getNurseBookinglist();
    }
  }

  getNurseListHistory(values) {
    this.pageno2 = 1;
    this.partBookingHistory = [];
    this.EmtyData = null;
    this.getNurseBookingHistory();
  }

  loadData2(event: any) {
    this.scrollEvent = event;
    if (this.nextCount1 == 0) {
      event.target.disabled = true;
    } else {
      this.pageno2 += 1;
      this.getNurseBookingHistory();
    }
  }


  getNurseBookinglist() {
    if (this.bookListReq) {
      this.bookListReq.unsubscribe();
    }
    let requestdata = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "pageno": this.pageno1,
      "limit": 10
    });
    this.bookListReq = this.services.postRequest("getNurseBookinglist", requestdata).subscribe(response => {
      if (this.refEvent) {
        this.refEvent.target.complete();
      }
      if (this.scrollEvent) {
        this.scrollEvent.target.complete();
      }
      this.EmtyData = response.status;
      if (response.status > 0) {
        for (let item of response.data[0].details) {
          this.NurseBooking.push(item);
        }
        this.nextCount = response.data[0].nextCount;
        console.log("nextCount1 => ", this.nextCount);
      }
    })
  }

  async cancelBkng(bookingId, bookingAmnt) {
    this.nurseBookingId = bookingId;
    const modal = await this.modalCtrl.create({
      component: CancelbookingPage,
      cssClass: 'ModelConCSSCancelPopUp',
      componentProps: {
        bookingId: bookingId,
        bookingAmnt: bookingAmnt
      },
    });
    modal.onDidDismiss()
      .then((data) => {
        const res = data;
        console.log(res);
        this.presentLoading();
        if (res.data != null) {
          this.patientNurseCancelBooking();
        }
      });
    return await modal.present();
  }

  patientNurseCancelBooking() {
    if (this.cancelNurseReq) {
      this.cancelNurseReq.unsubscribe();
    }
    console.log("booking Id => ", this.nurseBookingId);
    let requestdata = JSON.stringify({
      "nurseBookingId": this.nurseBookingId,
      "patientId": localStorage.getItem("patient_id")
    });
    this.cancelNurseReq = this.services.postRequest("patientNurseCancelBooking", requestdata).subscribe(response => {
      console.log(response);
      if (response.status == 1) {
        setTimeout(() => {
          this.loadingController.dismiss();
        }, 500);

        if (response.data[0].msgcode == 1) {
          console.log('msg log');
          this.Alertpopup("Your booking canceled successfully. Amount will be refunded within 7 working days", response.status);
        } else if (response.data[0].msgcode == 2) {
          this.Alertpopup("you reached your cancelation limit,Your booking canceled successfully. Amount will be refunded within 7 working days", response.status);
        } else if (response.data[0].msgcode == 3) {
          this.Alertpopup("you reached your cancelation limit,so unable to cancel your booking", 0);
        }
        this.getNurseList(1);
      } else {
        setTimeout(() => {
          this.loadingController.dismiss();
        }, 500);
        this.Alertpopup(response.msg, response.status);
      }
    });
  }

  showdutyarray: any = [];
  frontdateshow: any = [];
  particularBookingDetails() {
    debugger
    this.isShowHeaderValue = true;
    if (this.partBookDetReq) {
      this.partBookDetReq.unsubscribe();
    }
    this.EmtyData = null;
    let requestdata = JSON.stringify({
      "nurseBookingId": this.nurseBookingId
    });
    this.partBookDetReq = this.services.postRequest("particularBookingDetails", requestdata).subscribe(response => {
      debugger;
      console.log(response);
      this.res = response;
      this.EmtyData = response.status;
      if (response.status > 0) {
        this.partBookingDetails = response.data;
        this.startDate1 = new Date(response.data[0].from_date);
        this.endDate1 = new Date(response.data[0].to_date);
        let timeDifference = this.endDate1 - this.startDate1;
        this.dayDifference = (timeDifference / (1000 * 3600 * 24)) + 1;
        let displayValue;
        displayValue = localStorage.getItem("selectedLanguage") === "en" 
        ? `${this.dayDifference} day${this.dayDifference > 1 ? 's' : ''}` 
        : `${this.dayDifference} ${this.dayDifference > 1 ? 'أيام' : 'يوم'}`;
              this.displayValue = displayValue;
        for (let item of response.data[0]?.designedDuties) {
          this.dtyArray.push(" " + item.duties);
        }
        this.showdutyarray = this.dtyArray.slice(0, 2);
        this.dtyArr = this.dtyArray.toString();
        if (response.data[0].excluded_date) {
          let dates = response.data[0].excluded_date.split(",");
          this.dateRange = [];
          this.frontdateshow = [];
          for (let item of dates) {
            this.frontdateshow.push(this.getFormattedDateTime(item, 'Date1'))
            this.dateRange.push(this.getFormattedDateTime(item, 'Date1'));
          }
          this.myDates = response.data[0].excluded_date;
        } else {
          this.dateRange = [];
        }
      }
    })
  }

  async showaddress(address, myEvent) {
    let popover = await this.popoverctrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        address: address,
        from: "doctorBKFC"
      },
      translucent: true,
      cssClass: 'offrMod'
    });
    return await popover.present();
  }

  async viewMore(frm: any, cname: any) {
    debugger
    console.log(" Excluded Dates --> ", this.dateRange);
    console.log("dates",);
    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        duties: this.dtyArray,
        excdat: this.dateRange,
        month: this.month,
        year: this.year,
        showformated_date: new Date().toString().split(' ')[0] + ", " + new Date().toString().split(' ')[1] + " " + new Date().toString().split(' ')[2]
      },
      cssClass: cname,
    });
    return await popover.present();
  }

  getNurseBookingHistory() {
    if (this.nurseBookHisReq) {
      this.nurseBookHisReq.unsubscribe();
    }
    let requestdata = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "pageno": this.pageno2,
      "limit": 10
    });
    this.nurseBookHisReq = this.services.postRequest("getNurseBookingHistory", requestdata).subscribe(response => {
      console.log(response);
      this.nextCount1 = response.data[0]?.nextCount;
      if (this.refEvent) {
        this.refEvent.target.complete();
      }
      if (this.scrollEvent) {
        this.scrollEvent.target.complete();
      }
      this.EmtyData = response.status;
      if (response.status == 1) {
        for (let item of response.data[0].details) {
          this.partBookingHistory.push(item);
        }
        console.log("nextCount2 => ", this.nextCount1);
      }
    })
  }

  getBkgDateCale(fromDate, toDate) {
    debugger
    this.storeDates = [];
    const FromDate = new Date(fromDate);
    const ToDate = new Date(toDate);
    let exStatus = false;

    let prevDate = new Date(FromDate.getFullYear(), FromDate.getMonth(), 0).getDay();
    console.log("prevDate", prevDate);
    if (prevDate < 6) {
      for (let i = prevDate; i >= 0; i--) {
        this.storeDates.push({
          fullDate: " ",
          year: " ",
          month: " ",
          date: " ",
          excldDate: exStatus
        });
      }
    }
    console.log("?joy", this.storeDates);

    let monthEnd = new Date(FromDate.getFullYear(), FromDate.getMonth() + 1, 0).getDate();
    console.log("monthEnd=>", monthEnd);
    for (let i = 1; i <= monthEnd; i++) {
      for (let item of this.excludedDate) {
        let eD = new Date(item);
        let exDate = new Date(eD.getFullYear(), eD.getMonth(), eD.getDate()).toDateString();
        let date = new Date(FromDate.getFullYear(), FromDate.getMonth(), i).toDateString();
        if (exDate == date) {
          exStatus = true;
          break;
        }
        else {
          exStatus = false;
        }
      }
      this.storeDates.push({
        fullDate: new Date(FromDate.getFullYear(), FromDate.getMonth(), i),
        year: FromDate.getFullYear(),
        month: FromDate.getMonth() + 1,
        date: i,
        excldDate: exStatus
      });
      exStatus = false;
    }
    console.log("storeDate=>", this.storeDates);
  }

  next() {
    debugger
    if (this.myFromDate.getDate() != 1) {
      this.nextBtn = false;
      this.prevBtn = true;
      let curr = this.currentMon.getMonth() + 1;
      let toMon = this.myToDate.getMonth() + 1;
      if (curr < toMon) {
        if (this.nextMon == "") {
          var nextMonth = new Date(this.myFromDate.getFullYear(), this.myFromDate.getMonth() + 1, 1);
          this.nextMon = nextMonth
        } else {
          nextMonth = new Date(this.currentMon.getFullYear(), this.currentMon.getMonth() + 1, 1);
          this.currentMon = nextMonth
        }
        let dateArray = String(nextMonth).split(" ");
        this.getBkgDateCale(new Date(nextMonth), new Date(this.myToDate));
        this.year = dateArray[3];
        this.month = dateArray[1];
      }
    }
  }
  prvMon: any = "";
  prev() {
    debugger
    let curr = this.currentMon.getMonth() + 1;
    let fromMon = this.myFromDate.getMonth() + 1;
    if (curr > fromMon) {
    this.nextBtn = true;
    this.prevBtn = false;
    let dateArray = String(this.myFromDate).split(" ");
    let prvious = new Date(this.currentMon.getFullYear(), this.currentMon.getMonth() - 1, 1);
    this.currentMon = new Date(this.currentMon.getFullYear(), this.currentMon.getMonth() - 1, 1);
      this.getBkgDateCale(new Date(prvious), new Date(this.myToDate));
      this.year = dateArray[3];
      this.month = dateArray[1];
  }
  }

  async reviewPopup(nurseID, proImg, nurseName, reviewcount, nursebookingid) {
    console.log(reviewcount, "check reviewcount");
    if (reviewcount == 0) {
      const alert = await this.modalCtrl.create({
        component: ReviewPage,
        cssClass: 'review-class',
        componentProps: {
          Id: nurseID,
          Img: proImg,
          Name: nurseName,
          From: "Nurse",
          bookingId: nursebookingid,
        }
      });
      alert.onDidDismiss().then((data) => {
        console.log(data);
        if (data.data == 'dismiss') {
          this.openHistory()
        }

      })
      await alert.present();
    }
  }

  async definedduties(id, name, profile) {
    const modal = await this.modalCtrl.create({
      component: DefinedDutiesPage,
      cssClass: 'definedduties',
      componentProps: {
        Nurse_ID: id,
        Nurse_Name: name,
        Nurse_Profile: profile,
      },
    });
    // modal.onDidDismiss()
    // .then((data) => {
    //   if (data.data == 'dismiss') {
    //   }
    // });
    return await modal.present();
  }



}

